
(function () {
  'use strict';

  if (window.__junisStockDisplayLoaded) return;
  window.__junisStockDisplayLoaded = true;

  const SELECTOR = '.junis-stock-display[data-sku]';
  const CHUNK = 250;

  const LABEL = {
    ENOUGH: 'In stock',
    LOW: 'Out of stock',
    OUT: 'Out of stock',
    UNKNOWN: 'Stock unknown',
    COMING_SOON: 'Coming soon',
  };

  const fetchStock = async (skus) => {
    const map = new Map();
    const locQs = window.__junisCompanyLocationId
      ? '&companyLocationId=' + encodeURIComponent(window.__junisCompanyLocationId)
      : '';
    const chunks = [];
    for (let i = 0; i < skus.length; i += CHUNK) chunks.push(skus.slice(i, i + CHUNK));
    await Promise.all(
      chunks.map(async (chunk) => {
        try {
          const url =
            '/apps/wishtrade/stock?skus=' +
            encodeURIComponent(chunk.join(',')) + locQs;
          const resp = await (window.junisFetch || fetch)(url, { headers: { Accept: 'application/json' }, junisRetries: 1 });
          if (!resp.ok) return;
          const data = await resp.json();
          if (!data || !Array.isArray(data.stock)) return;
          for (const s of data.stock) {
            if (s && s.sku) map.set(s.sku, s);
          }
        } catch {
          // 무시
        }
      }),
    );
    return map;
  };

  const hydrate = (elements, stockMap) => {
    for (const el of elements) {
      const sku = el.dataset.sku;
      const stock = stockMap.get(sku);
      const badge = el.querySelector('.junis-stock-display__badge');
      const labelEl = el.querySelector('.junis-stock-display__label');
      if (!badge || !labelEl) continue;

      if (!stock || !stock.level) {
        // 응답 누락 → placeholder 그대로 (badge hidden)
        continue;
      }

      el.dataset.level = stock.level;
      labelEl.textContent = LABEL[stock.level] ?? stock.level;
      badge.hidden = false;

      if (stock.purchasable === false) {
        var scope = el.closest('.product-information') || el.closest('.product-details') || document;
        scope.querySelectorAll(
          'product-price, product-form-component, add-to-cart-component, .buy-buttons-block, .accelerated-checkout-block, .shopify-payment-button'
        ).forEach(function (b) { b.style.display = 'none'; });
        if (!document.querySelector('[data-junis-preparing-note]')) {
          var note = document.createElement('p');
          note.setAttribute('data-junis-preparing-note', '1');
          note.className = 'junis-preparing-note';
          note.textContent = el.dataset.preparingLabel || '상품 준비중 — 가격 확정 후 주문할 수 있습니다.';
          (el.parentElement || el).appendChild(note);
        }
      }
    }
  };

  const init = async () => {
    const elements = document.querySelectorAll(SELECTOR);
    if (!elements.length) return;

    const skus = [
      ...new Set([...elements].map((el) => el.dataset.sku).filter(Boolean)),
    ];
    if (skus.length === 0) return;

    const stockMap = await fetchStock(skus);
    hydrate(elements, stockMap);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // 오프라인/단절 중 placeholder 로 남은 신호등을 온라인 복귀 시 자동 재hydrate.
  //   stock 은 서버 60s 캐시 + 브라우저 HTTP 캐시라 재요청 비용 낮음.
  window.addEventListener('online', init);
})();
